import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {CommonComponent} from '../common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent extends CommonComponent implements OnInit {
  showSocialNetworks = environment.footer.showSocialNetworks;
  textPrimaryColor = environment.footer.textPrimaryColor;
  bgSecondaryColor = environment.footer.bgSecondaryColor;
  bgColor = environment.footer.bgColor;
  programName = environment.productName;
  termConAlignLeft = environment.footer.termConAlignLeft;
  // urlDoc4: string;
  urlDoc10: string;
  privacyPolicy: string;
  termsConditions: string;
  facebook = environment.socialNetworks.facebook;
  instagram = environment.socialNetworks.instagram;
  tiktok = environment.socialNetworks.tiktok;
  twitter = environment.socialNetworks.twitter;
  youtube = environment.socialNetworks.youtube;
  linkedin = environment.socialNetworks.linkedin;
  disclaimer: string;
  language: string;
  isMobileDevice: boolean = false;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private configurationService: ConfigurationService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.locale = this.locale.substring(0, 2);
    this.language = this.locale;
    configurationService.configReceive.subscribe(
      () => {
        this.setFooterDisclamer(this.language);
      }
    );
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.language = this.translate.currentLang === 'en' ? 'en' : 'es';
        this.setFooterDisclamer(this.language);
      });
  }

  ngOnInit(): void {
    //this.isMobileDevice = this.isMobile();
    // this.urlDoc4 = `assets/documents/doc4_${this.locale}.pdf`;

    this.setFooterDisclamer(this.locale);
  }

  setFooterDisclamer(language: string) {
    // this.urlDoc4 = `assets/documents/doc4_${language}.pdf`;
    // TODO una vez que se haga el doc 11 para español dejar la siguiente linea en vez del if
    this.urlDoc10 = `assets/documents/doc11_${this.language}.pdf`;
    if (language === 'es'){
      this.disclaimer = this.configurationService.home.footerDisclaimerEs;
    } else{
      this.disclaimer = this.configurationService.home.footerDisclaimerEn;
    }
  }

  isMobile(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegex.test(userAgent);
  }

}
